import { Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AccessoryCardComponent } from './accessory-card.component';

@Component({
  selector: 'app-coupling-module',
  standalone: true,
  imports: [NgFor, AccessoryCardComponent, TranslateModule],
  template: `
    <div class="coupling-module">
      <h3>{{ 'labels.trailer' | translate }}: {{ coupling?.plate }}</h3>
      <div *ngFor="let accessory of coupling?.accessories">
        <app-accessory-card [accessory]="accessory"></app-accessory-card>
      </div>
    </div>
  `
})
export class CouplingModuleComponent {
  @Input() coupling: any;
}
